const MUTATIONS = {
  cacheList (state, payload) {
    const index = state.cacheList.findIndex(item => item.url === payload.url)
    if (index >= 0) {
      state.cacheList[index] = payload
    } else {
      if (state.cacheList.length >= 10) {
        state.cacheList[0] = payload
      } else {
        state.cacheList.push(payload)
      }
    }
  }
}

export default MUTATIONS



// WEBPACK FOOTER //
// ./src/store/modules/api/mutations.js